import React from 'react';
import { Icon } from './Icon.tsx';
import { Button } from './Button.tsx';

// ============================================================================
// EmptyState — Contextual placeholder for empty modules
// ============================================================================

export interface EmptyStateAction {
    label: string;
    onClick: () => void;
    variant?: 'primary' | 'secondary';
}

export interface EmptyStateProps {
    icon: string;
    title: string;
    description?: string;
    /** Legacy: pass any ReactNode as a single action */
    action?: React.ReactNode;
    /** Structured actions rendered as Button components */
    actions?: EmptyStateAction[];
    className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ 
    icon, 
    title, 
    description, 
    action,
    actions,
    className = ''
}) => (
        <div className={`flex animate-fadeIn flex-col items-center justify-center py-16 text-center ${className}`}>
            <Icon 
                name={icon} 
                size="xl" 
                className="mb-4 text-[color:var(--text-light)] dark:text-[color:var(--text-dark)]"
            />
            <h3 className="mb-1 font-medium text-[color:var(--text-light)] text-lg dark:text-[color:var(--text-dark)]">
                {title}
            </h3>
            {description ? <p className="mb-4 max-w-sm text-[color:var(--text-light)] text-sm dark:text-[color:var(--text-dark)]">
                    {description}
                </p> : null}
            {actions && actions.length > 0 ? <div className="mt-3 flex items-center gap-3">
                    {actions.map((a) => (
                        <Button
                            key={a.label}
                            variant={a.variant === 'secondary' ? 'ghost' : 'primary'}
                            size="sm"
                            onClick={a.onClick}
                        >
                            {a.label}
                        </Button>
                    ))}
                </div> : null}
            {action && !actions ? <div className="mt-2">
                    {action}
                </div> : null}
        </div>
    );














